import React, { useEffect, useState } from 'react';
import { UserPlus, ChevronLeft, ChevronRight } from 'lucide-react';
import { Card } from '../ui/Card';
import { mockCandidates } from '../../utils/mockData';
import { getMonthDays, getToday } from '../../utils/dateUtils';
export function EmployeesStartingCalendarWidget() {
  const [currentDate, setCurrentDate] = useState(getToday());
  const [calendarDays, setCalendarDays] = useState<(Date | null)[]>([]);
  const [startDateMap, setStartDateMap] = useState<Record<number, number>>({});
  useEffect(() => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    setCalendarDays(getMonthDays(year, month));
    const counts: Record<number, number> = {};
    mockCandidates.forEach(candidate => {
      const startDate = new Date(candidate.startDate);
      if (startDate.getMonth() === month && startDate.getFullYear() === year) {
        const day = startDate.getDate();
        counts[day] = (counts[day] || 0) + 1;
      }
    });
    setStartDateMap(counts);
  }, [currentDate]);
  const nextMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  const prevMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  const monthName = currentDate.toLocaleString('default', {
    month: 'long',
    year: 'numeric'
  });
  const today = getToday();
  return <Card title="Employees Starting" icon={<UserPlus className="h-4 w-4" data-id="element-1018" />} action={<div className="flex items-center gap-1" data-id="element-1019">
          <button onClick={prevMonth} className="p-1 hover:bg-orange-50 rounded-full transition-colors" data-id="element-1020">
            <ChevronLeft className="h-3.5 w-3.5 text-gray-600" data-id="element-1021" />
          </button>
          <span className="text-[11px] font-medium w-20 text-center text-gray-700" data-id="element-1022">
            {monthName}
          </span>
          <button onClick={nextMonth} className="p-1 hover:bg-orange-50 rounded-full transition-colors" data-id="element-1023">
            <ChevronRight className="h-3.5 w-3.5 text-gray-600" data-id="element-1024" />
          </button>
        </div>} data-id="element-1017">
      <div className="space-y-1.5" data-id="element-1025">
        <div className="grid grid-cols-7 gap-0.5 text-center" data-id="element-1026">
          {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((d, i) => <div key={`${d}-${i}`} className="text-[9px] font-medium text-gray-400 py-0.5" data-id="element-1027">
              {d}
            </div>)}
        </div>
        <div className="grid grid-cols-7 gap-0.5" data-id="element-1028">
          {calendarDays.map((date, idx) => {
          if (!date) return <div key={`empty-${idx}`} className="h-6" data-id="element-1029" />;
          const dayNum = date.getDate();
          const count = startDateMap[dayNum];
          const isToday = date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
          return <div key={idx} className={`h-6 flex flex-col items-center justify-center rounded text-[10px] relative ${isToday ? 'bg-gradient-to-br from-orange-50 to-orange-100 text-orange-700 font-bold border border-orange-200 shadow-sm' : 'hover:bg-gray-50 text-gray-700'} ${count ? 'cursor-pointer' : ''}`} title={count ? `${count} employee${count > 1 ? 's' : ''} starting` : undefined} data-id="element-1030">
                <span data-id="element-1031">{dayNum}</span>
                {count > 0 && <div className="absolute bottom-0.5 h-0.5 w-0.5 rounded-full bg-green-600" data-id="element-1032" />}
              </div>;
        })}
        </div>
      </div>
    </Card>;
}